import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1 } from "../../../../config/constants";
// Components
import Graphic from "../../../graphic";

const RestPerformancePlot = ({ recordings }) => {
  const [positions, setPositions] = useState([]);
  const [restValues, setRestValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let rest = [];

    recordings.forEach((recording, i) => {
      positions.push(i + 1);
      rest.push(recording.hasOwnProperty("restPerformance") ? recording.restPerformance : NaN);
    });

    setPositions(positions);
    setRestValues(rest);

    return () => {
      setPositions([]);
      setRestValues([]);
    };
  }, [recordings]);

  const data = {
    labels: positions,
    datasets: [
      {
        label: t("reports.performanceGraphic.legend1"),
        data: restValues,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
        spanGaps: true,
      },
    ],
  };

  return (
    <Graphic
      Title={t("reports.performanceGraphic.title")}
      Type={Line}
      data={data}
      axisY={t("reports.performanceGraphic.axisY")}
      axisX={t("reports.performanceGraphic.axisX")}
    />
  );
};

export default RestPerformancePlot;
